import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';
import { HabbitLogo } from '../HabbitLogo';
export function MarketingNav() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/80 backdrop-blur-md border-b border-surface-200/50" data-id="element-202">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-203">
        <Link to="/" className="flex items-center gap-3" data-id="element-204">
          <HabbitLogo size={34} data-id="element-205" />
          <span className="text-2xl font-mono font-bold tracking-tight text-gray-100" data-id="element-206">
            habbit<span className="text-centurion-500" data-id="element-207">.</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6" data-id="element-208">
          <a href="#how-it-works" className="text-sm font-medium text-gray-400 hover:text-gray-200 transition-colors" data-id="element-209">
            How It Works
          </a>
          <Link to="/app" className="bg-centurion-500 hover:bg-centurion-400 text-surface-600 px-5 py-2.5 rounded-full text-sm font-bold tracking-wide transition-all flex items-center gap-2" data-id="element-210">
            Start Challenge <ArrowRight size={16} data-id="element-211" />
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsOpen(!isOpen)} data-id="element-212">
          {isOpen ? <X size={24} data-id="element-213" /> : <Menu size={24} data-id="element-214" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden absolute top-20 left-0 right-0 bg-surface-500 border-b border-surface-200 p-6 flex flex-col gap-4 shadow-2xl" data-id="element-215">
          <a href="#how-it-works" onClick={() => setIsOpen(false)} className="text-lg font-medium text-gray-300 hover:text-white py-2" data-id="element-216">
            How It Works
          </a>
          <Link to="/app" onClick={() => setIsOpen(false)} className="bg-centurion-500 text-surface-600 px-5 py-3 rounded-lg text-center font-bold mt-2 flex items-center justify-center gap-2" data-id="element-217">
            Start Challenge <ArrowRight size={18} data-id="element-218" />
          </Link>
        </div>}
    </nav>;
}